module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image10-c9ab1f1d7c0cdbbecc7b3668349d63be.png";